import { Body, Box, Caption, Divider, Grid, Heading } from "@biom3/react";

type RewardCardProps = {
  caption: string;
  title: string;
  description: string;
};

const RewardCard = ({ caption, title, description }: RewardCardProps) => {
  return (
    <Box
      sx={{
        bg: "base.color.neutral.500",
        height: "100%",
        width: "100%",
        borderRadius: "8px",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box sx={{ p: "base.spacing.x6", flex: 1 }}>
        <Box sx={{ mb: "base.spacing.x2" }}>
          <Caption
            size="small"
            weight="bold"
            sx={{
              color: "base.color.text.caption.primary",
            }}
          >
            {caption}
          </Caption>
        </Box>

        <Box sx={{ mb: "base.spacing.x2" }}>
          <Heading
            size="medium"
            weight="bold"
            sx={{
              color: "base.color.text.heading.primary",
            }}
          >
            {title}
          </Heading>
        </Box>

        <Box>
          <Body
            size="small"
            sx={{
              color: "base.color.text.body.secondary",
            }}
          >
            {description}
          </Body>
        </Box>
      </Box>
    </Box>
  );
};

export const RewardContentSection = () => {
  const rewardsInfo = [
    {
      id: "rewards-card-1",
      caption: "Real gamers, real rewards",
      title: " Skill > Sybils",
      description:
        "We're committed to delivering fair and meaningful rewards by excluding Sybils and bots. You can rest assured that each Gem you redeem reflects authentic, skilful gameplay.",
    },
    {
      id: "rewards-card-2",
      caption: "Sustainability at the Core",
      title: "Lasting Rewards",
      description:
        "We're in it for the long run - our rewards system fosters real engagement and delivers enduring value for authentic gamers.",
    },
    {
      id: "rewards-card-3",
      caption: "Beta and Beyond",
      title: "Join the Journey",
      description:
        "This weekly Gem redemption is only the first step. We'll continue rolling out new features so you can dive deeper, unlock fresh utilities, and earn bigger rewards.",
    },
  ];

  return (
    <Box sx={{ width: "100%", mt: "base.spacing.x6" }}>
      <Divider
        sx={{
          bg: "base.color.translucent.emphasis.100",
          mb: "base.spacing.x4",
        }}
      />

      <Heading
        size="medium"
        weight="bold"
        sx={{
          mb: "base.spacing.x6",
          color: "base.color.text.heading.primary",
        }}
      >
        About Perpetual Rewards
      </Heading>
      <Grid
        sx={{
          gap: "base.spacing.x6",
          width: "100%",
          gridTemplateColumns: {
            default: "1fr",
            medium: "repeat(auto-fill, minmax(330px, 1fr))",
            large: "repeat(3, 1fr)",
          },
        }}
      >
        {rewardsInfo.map((card) => (
          <RewardCard
            key={card.id}
            caption={card.caption}
            title={card.title}
            description={card.description}
          />
        ))}
      </Grid>
    </Box>
  );
};
